import { client } from '@/apollo/vue-apollo';
import { gql } from 'graphql-tag';

export function invoiceUploadAttachment(
	participant: string,
	legalEntity: string,
	recipient: string,
	invoice: string,
	attachmentType: string,
	name: string,
	metadata: any
) {
	const mutation = gql`
	mutation ComponentsInvoiceDisputes_upload_invoice_document_attachment(
	  $participant: uuid!
	  $legalEntity: uuid!
	  $recipient: uuid!
	  $invoice: uuid
	  $attachmentType: risolto_document_attachment_type_enum!
	  $name: String!
	  $metadata: jsonb!
	) {
	  insert_risolto_invoice_document_attachment_one(
		object: {
		  invoice: $invoice
		  participant: $participant
		  legal_entity: $legalEntity
		  recipient: $recipient
		  attachment_type: $attachmentType
		  name: $name
		  metadata: $metadata
		}
	  ) {
		reference
	  }
	}
	`;

	return client.mutate({
		mutation,
		variables: {
			participant,
			legalEntity,
			recipient,
			invoice,
			attachmentType,
			name,
			metadata
		}
	});
}

export async function invoiceDeleteAttachment(
	key: any
) {
	const search = gql`
	query ComponentsInvoiceDisputes_find_invoice_document_attachment($search: jsonb!)
	{
	  risolto_invoice_document_attachment(
		where: {
		  metadata: { _contains: $search }
		}
	  ) {
		reference
	  }
	}
	`;

	const remove = gql`
	mutation ComponentsInvoiceDisputes_delete_invoice_document_attachment(
	  $reference: uuid!
	) {
	  delete_risolto_invoice_document_attachment_by_pk(reference: $reference) {
		reference
	  }
	}
	`;

	const result = await client.query({
		query: search,
		variables: {
			search: {
				key: key
			}
		}
	});

	if (result.data.risolto_invoice_document_attachment.length === 0) {
		throw new Error('Attachment not found');
	}

	const reference = result.data.risolto_invoice_document_attachment[0].reference;

	return client.mutate({
		mutation: remove,
		variables: {
			reference
		}
	});
}
